<template>
  <div class="share-dialog" @contextmenu.stop>
    <el-dialog
      :title="title"
      width="450px"
      top="calc( 50vh - 150px )"
      custom-class="book-share"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :handleCancel="handleCancel"
    >
      <div class="share-dialog-container">
        <div class="info">
          {{ language.scanQrCodeMobileReading }}
        </div>
        <vue-qr ref="qrCode" :text="qrObjPage.value" :size="88" :margin="5" />
        <div class="downloadCode" @click="goDownload">{{ language.downloadQrCode }}</div>
        <p class="generatePos" v-show="selposter">
          <span @click="goPoster">{{ language.generatePoster }}</span>
        </p>
        <div class="share-content">
          <div class="share-item">
            <div class="share-input">{{ qrObjPage.value }}</div>
            <div class="share-btn tag-read" @click="handleCopy" :data-clipboard-text="qrObjPage.value">{{ language.copyLink }}</div>
          </div>
          <div class="share-item" v-if="inSetShow">
            <div class="share-input">{{ qrObj.iframeUrl }}</div>
            <div class="share-btn tag-read" @click="handleCopy" :data-clipboard-text="qrObj.iframeUrl">{{ language.copyIFrameCode }}</div>
          </div>
          <div v-if="isShowPageOption" class="share-item option">
            <el-checkbox style="margin-bottom: 10px" v-model="isSharePage" @change="changeSharePage">{{ currentLang === 1 ? 'Share this page' : '分享当前页' }}</el-checkbox
            ><br />
            <el-radio-group v-if="currentPageArray[0] !== 0 && currentPageArray[1] !== 0 && currentPageArray.length == 2" v-model="sharePage" :disabled="!isSharePage" @change="changeSharePage">
              <el-radio :label="0">{{ currentLang === 1 ? 'Share left page' : '分享左页' }}</el-radio>
              <el-radio :label="1">{{ currentLang === 1 ? 'Share right page' : '分享右页' }}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="share-button" v-if="showButtons && showButtons.length > 0">
          <div class="button" v-if="showButtons[0]" @click="handleClick(1)">编辑分享效果</div>
          <div class="button" v-if="showButtons[2]" @click="handleClick(3)">设置显示功能</div>
          <div class="button" v-if="showButtons[1]" @click="handleClick(2)">设置分享内容</div>
        </div>
      </div>
    </el-dialog>
    <Poster ref="poster" :qrObj="qrObjPage" :typeName="typeName" :current-lang="currentLang"></Poster>
    <QrCodeDownlaod v-if="qrDownload" :qrObj="qrObjPage" @closeDownload="closeDownload"></QrCodeDownlaod>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import Clipboard from 'clipboard'
import Poster from '@components/poster'
import QrCodeDownlaod from './qrCodeDownload'
import compareVipRight from '@components/common/compareVipRight.js'
export default {
  name: 'ShareDialog',
  mixins: [compareVipRight],
  data() {
    return {
      dialogVisible: false,
      typeName: '书刊',
      qrDownload: false,
      isSharePage: false,
      sharePage: null,
      qrObjPage: { ...this.qrObj }
    }
  },
  props: {
    qrObj: {
      type: Object,
      default: function() {
        return {}
      }
    },
    qrVal: {
      type: String,
      default: ''
    },
    isInset: Boolean,
    showButtons: {
      type: Array,
      default: null
    },
    title: {
      default: '分享书刊'
    },
    currentLang: {
      default: 0
    }
  },
  computed: {
    selposter() {
      return this.$store.state.config.poster.poster && this.title.indexOf('分享报纸') < 0 && this.title.indexOf('分享全部报纸') < 0
    },
    inSetShow() {
      return this.isInset && this.compare({ type: 'boole', key: 'embedWebsite' })
    },
    language() {
      return this.$store.state.config.languageOptions[this.currentLang]
    },
    currentPageArray() {
      return this.$store.state.book.currentPage
    },
    isShowPageOption() {
      return (this.$route.path.indexOf('book') > 0 || this.$route.path.indexOf('content') > 0 || this.$route.path.indexOf('paper') > 0) && this.qrObj.value.toLowerCase().indexOf('content') > 0
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.isSharePage = false
        this.sharePage = null
        this.qrObjPage = { ...this.qrObj }
      }
    }
  },
  components: { VueQr, Poster, QrCodeDownlaod },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    handleCopy() {
      let clipboard = new Clipboard('.tag-read')
      clipboard.on('success', (e) => {
        this.$message({
          message: this.currentLang === 1 ? 'Success' : '复制成功',
          type: 'success'
        })
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        console.log('该浏览器不支持自动复制')
        clipboard.destroy()
      })
    },
    handleClick(val) {
      this.$emit('handleClick', val)
    },
    goPoster() {
      this.$refs.poster.dialogVisible = true
      this.dialogVisible = false
    },
    goDownload() {
      this.qrDownload = true
    },
    closeDownload() {
      this.qrDownload = false
    },
    changeSharePage() {
      let newHref = this.qrObj.value
      if (this.qrObjPage.value.indexOf('&page=')) {
        newHref = this.qrObj.value.replace(/&page=\d+/, '')
      }
      if (this.isSharePage) {
        this.qrObjPage.value = newHref + '&page=' + Math.max(this.currentPageArray[this.sharePage || 0] || 1)
      } else {
        this.sharePage = null
        this.qrObjPage.value = newHref
      }
    }
  },
  mounted() {
    // this.getVipInfo()
  },
  created() {}
}
</script>
<style lang="scss">
.share-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
}
.share-dialog-container {
  text-align: center;
  padding: 19px 0 27px 0;
  margin: 0 auto;
  .info {
    font-size: 14px;
  }
  .generatePos {
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    span {
      color: #df5813;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .share-content {
    margin-top: 20px;
    .share-item {
      margin-bottom: 10px;
      .share-input {
        display: inline-block;
        width: 250px;
        height: 40px;
        padding: 0 10px;
        line-height: 40px;
        text-align: left;
        border: 1px solid rgba(151, 151, 151, 1);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: top;
      }
      .share-btn {
        display: inline-block;
        width: 120px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        margin-left: 10px;
        border: 1px solid rgba(223, 88, 19, 1);
        color: rgba(223, 88, 19, 1);
        cursor: pointer;
      }
    }
  }
  .share-button {
    display: flex;
    justify-content: space-evenly;
    .button {
      width: 100px;
      height: 27px;
      line-height: 27px;
      background-color: #df5813;
      color: #ffffff;
      font-size: 12px;
      cursor: pointer;
      margin-right: 10px;
    }
  }
}
.book-share {
  height: 300px;
  .el-dialog__header {
    height: 30px;
    line-height: 30px;
    padding: 0;
    background: #f4f4f4;
    .el-dialog__title {
      height: 100%;
      line-height: 30px;
      font-size: 14px;
      display: inline-block;
      color: #000;
    }
    .el-dialog__headerbtn {
      top: 8px;
      right: 8px;
      width: 14px;
      height: 14px;
    }
  }
  .share-item {
    .share-input,
    .share-btn {
      height: 26px !important;
      line-height: 26px !important;
      font-size: 12px !important;
    }
    .share-input {
      width: 160px !important;
    }
    .share-btn {
      width: 90px !important;
    }
  }
  .el-dialog__body {
    padding: 0 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 270px;
  }
  .share-dialog-container {
    padding: 0 !important;
  }
  .downloadCode {
    width: fit-content;
    padding-right: 5px;
    padding-left: 5px;
    height: 20px;
    line-height: 20px;
    background: #df5813;
    // box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    margin: 0 auto;
    color: #fff;
    cursor: pointer;
    font-size: 12px;
    margin-bottom: 10px;
  }
  .generatePos {
    margin: 10px 0 !important;
  }
  .share-content {
    margin-top: 0 !important;
  }
  .info {
    font-size: 12px !important;
  }
}
</style>
